import isDefaultSiteFooter from './is-default-site-footer';
import isDefaultSiteHeader from './is-default-site-header';
import isDialogVisible from './is-dialog-visible';

export default {
  isDefaultSiteFooter,
  isDefaultSiteHeader,
  isDialogVisible,
};
